import React, { useEffect, useState } from 'react';
import { crmApi } from '../api/crm';
import { useToast } from '../hooks/useToast';
import { useNavigate } from 'react-router-dom';

const FollowUps: React.FC = () => {
  const { showToast } = useToast();
  const nav = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const [overdue, setOverdue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState<any>(null);
  const [fu, setFu] = useState<any>({ action_date:new Date().toISOString().split('T')[0], channel:'call', note:'', next_action_date:'' });

  const fmt = (n:any) => Number(n||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  const today = new Date().toISOString().split('T')[0];

  const load = () => {
    setLoading(true);
    crmApi.due().then(r => { setRows(r.data.data || []); setOverdue(r.data.overdue || 0); })
      .catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const save = async () => {
    if (!fu.note.trim()) { showToast('Write what happened', 'error'); return; }
    try {
      await crmApi.followUp({
        ...fu,
        enquiry_id: target.kind === 'enquiry' ? target.id : null,
        contact_id: target.kind === 'account' ? target.id : null,
        next_action_date: fu.next_action_date || null,
      });
      showToast('Follow-up recorded');
      setTarget(null); load();
    } catch (e:any) { showToast(e.response?.data?.message || 'Could not save', 'error'); }
  };

  const th: React.CSSProperties = { padding:'8px 10px', fontSize:10, fontWeight:600, color:'var(--tx3)', textTransform:'uppercase', textAlign:'left' };

  if (target) return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Follow up — {target.name}</h1>
        <button className="btn btn-secondary" onClick={() => setTarget(null)}>Cancel</button>
      </div>
      <div className="card"><div className="card-body">
        <div style={{ fontSize:13, color:'var(--tx3)', marginBottom:12 }}>
          {target.ref} · {target.detail} {target.mobile ? ' · ' + target.mobile : ''}
        </div>
        <div className="form-grid-2">
          <div className="form-group"><label className="form-label">Date</label>
            <input type="date" className="form-control" value={fu.action_date} onChange={e => setFu({...fu, action_date:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">How</label>
            <select className="form-control" value={fu.channel} onChange={e => setFu({...fu, channel:e.target.value})}>
              <option value="call">Call</option><option value="visit">Visit</option>
              <option value="whatsapp">WhatsApp</option><option value="email">Email</option><option value="other">Other</option>
            </select></div>
        </div>
        <div className="form-group"><label className="form-label">What happened *</label>
          <textarea className="form-control" rows={3} value={fu.note} onChange={e => setFu({...fu, note:e.target.value})} autoFocus /></div>
        <div className="form-group"><label className="form-label">Next action date</label>
          <input type="date" className="form-control" style={{maxWidth:200}} value={fu.next_action_date} onChange={e => setFu({...fu, next_action_date:e.target.value})} /></div>
        <button className="btn btn-primary" onClick={save}>Save follow-up</button>
      </div></div>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Follow-ups due</h1>
        <button className="btn btn-secondary" onClick={load}>Refresh</button>
      </div>
      {overdue > 0 && <div style={{ fontSize:13, color:'var(--red)', marginBottom:12 }}>{overdue} overdue</div>}
      <div className="card">
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr style={{ background:'var(--sur2)' }}>
            <th style={th}>Due</th><th style={th}>Ref</th><th style={th}>Name</th><th style={th}>Mobile</th>
            <th style={th}>Detail</th><th style={{...th, textAlign:'right'}}>Owes</th><th style={th}>With</th><th></th>
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={8} style={{ padding:24, textAlign:'center', color:'var(--tx3)' }}>Loading...</td></tr>
            : rows.length === 0 ? <tr><td colSpan={8} style={{ padding:24, textAlign:'center', color:'var(--tx3)' }}>Nothing due — all caught up.</td></tr>
            : rows.map((r,i) => (
              <tr key={r.kind + r.id + i} style={{ borderBottom:'1px solid var(--bdr)' }}>
                <td style={{ padding:'8px 10px', fontSize:12, color: r.next_action_date < today ? 'var(--red)' : 'var(--tx2)', fontWeight: r.next_action_date < today ? 600 : 400 }}>
                  {r.next_action_date}{r.next_action_date < today ? ' · overdue' : ''}</td>
                <td style={{ padding:'8px 10px', fontSize:12, color:'var(--blue)' }}>{r.kind === 'enquiry' ? r.ref : 'Account'}</td>
                <td style={{ padding:'8px 10px', fontSize:12, fontWeight:600 }}>{r.name}</td>
                <td style={{ padding:'8px 10px', fontSize:12, fontFamily:'monospace' }}>{r.mobile || '-'}</td>
                <td style={{ padding:'8px 10px', fontSize:12, color:'var(--tx2)' }}>{String(r.detail || '').slice(0,40)}</td>
                <td className="td-num" style={{ padding:'8px 10px', color: Number(r.balance) > 0 ? 'var(--red)' : 'var(--tx3)' }}>{Number(r.balance) ? fmt(r.balance) : '-'}</td>
                <td style={{ padding:'8px 10px', fontSize:11, color:'var(--tx3)' }}>{r.assigned_name || '-'}</td>
                <td style={{ padding:'6px 10px', textAlign:'right', whiteSpace:'nowrap' }}>
                  <button className="btn btn-primary btn-sm" onClick={() => { setTarget(r); setFu({ action_date:today, channel: r.kind==='account'?'visit':'call', note:'', next_action_date:'' }); }}>Follow up</button>
                  {r.kind === 'enquiry' && <button className="btn btn-secondary btn-sm" style={{marginLeft:6}} onClick={() => nav('/enquiries')}>Open</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FollowUps;
